/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SelectSWMDialog.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { useEffect } from "react";
import { Box, Grid, Paper, Typography, Radio } from "@mui/material";
import React, { useState } from "react";
import { componentStyle } from "../../../../config/appTheme";
import SelectZone from "./SelectZone";
import CommonBreadcrumbs from "../../../../components/customComponentsV2/common/Breadcrumbs/CommonBreadcrumbs";
import SelectComponentList from "./SelectComponentList";
import { labCar } from "../../../../redux/actions";
import { useSelector } from "react-redux";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CustomRadioButtonV2, {
  checkedIconStyle,
  unCheckedIconStyle,
} from "../../../../components/customComponentsV2/common/radioButton/CustomRadioButtonV2";
import CustomRadioButtonWithoutForm from "../../../../components/customComponentsV2/common/radioButton/CustomRadioButtonWithoutForm";

function SelectSWMDialog({
  isZonalProject,
  zoneList = [],
  selectedZone,
  setSelectedZone,
  showZone,
  setShowZone,
  selectedEE,
  setSelectedEE,
  selectedSWM,
  setSelectedSWM,
  setSelectedZoneName,
  selectedZoneName,
  disabledSWMComponents = [],
  onSelectEEForSWM = () => { },
}) {
  const zone = "zone";
  const ee = "ee";
  const swm = "swm";

  const [eeComponentModifiedList, setEEComponentModifiedList] = useState([]);
  const [swmComponentModifiedList, setSwmComponentModifiedList] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);

  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [projectID, setProjectID] = useState(null);
  const [variantID, setVariantID] = useState(null);

  const selectedProjectDetails = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );
  const selectedSingleVariantDetails = useSelector(
    (state) => state.projectConfigReducer.selectedVariantDetails,
  );
  useEffect(() => {
    if (selectedProjectDetails?.project_id) {
      setProjectID(selectedProjectDetails?.project_id);
    }
    if (selectedSingleVariantDetails?.variant_id) {
      setVariantID(selectedSingleVariantDetails?.variant_id);
    }
  }, [selectedProjectDetails, selectedSingleVariantDetails]);

  const modifyEEData = (data) => {
    const modifiedList = data.map((item) => {
      return {
        data: item,
        id: item.ee_id,
        cardDataArray: [
          {
            key: "Number",
            value: item.assembly_number,
            keyStyle: { fontWeight: 600 },
            valueStyle: { fontWeight: 600 },
          },
          {
            key: "Description",
            value: item.description,
          },
          {
            key: "Version",
            value: item.version,
          },
        ],
      };
    });
    setEEComponentModifiedList(modifiedList);
  };

  const modifySWMData = (data) => {
    const modifiedList = data.map((item) => {
      return {
        data: item,
        id: item.ee_id,
        cardDataArray: [
          {
            key: "Number",
            value: item.name,
            keyStyle: { fontWeight: 600 },
            valueStyle: { fontWeight: 600 },
          },
          {
            key: "Description",
            value: item.description,
          },
          {
            key: "Version",
            value: item.version,
          },
        ],
      };
    });
    setSwmComponentModifiedList(modifiedList);
  };

  const getChangedZone = (zone, zoneName) => {
    setSelectedZone(zone);
    setSelectedZoneName(zoneName);
    setShowZone(ee);
  };

  return (
    <Box>
      {showZone === zone && (
        <Box>
          <Box sx={{ mb: 1 }}>
            <CommonBreadcrumbs
              items={[
                {
                  label: "Select Zone",
                },
              ]}
            />
          </Box>
          <SelectZone
            zoneList={zoneList}
            getChangedZone={getChangedZone}
            selectedZone={selectedZone}
          />
        </Box>
      )}
      {showZone === ee && (
        <Box>
          <Box sx={{ mb: 1 }}>
            <CommonBreadcrumbs
              color={"black"}
              items={[
                ...(isZonalProject
                  ? [
                    {
                      label: selectedZoneName,
                      onClick: () => {
                        setShowZone(zone);
                      },
                    },
                  ]
                  : []),
                {
                  label: "EE Component",
                },
              ]}
            />
          </Box>
          <Box>
            <Box>
              <SelectComponentList
                key={`ee-${projectID}-${variantID}-${selectedZone}`}
                dataList={eeComponentModifiedList}
                apiAction={labCar.get_ee_components_new}
                searchKey={"assembly_number"}
                placeholder={"Search EE"}
                page={page}
                rowsPerPage={rowsPerPage}
                handlePageChange={(page) => setPage(page)}
                totalCount={count}
                selectedComponentDetails={selectedEE}
                idKey={"ee_id"}
                onClick={(item) => {
                  setSelectedEE(item.data);
                  onSelectEEForSWM(item.data);
                  setShowZone(swm);
                }}
                renderSelectIcon={(data) => {
                  return (
                    <Box
                    //   sx={{ pl: 1.5, pt: 2 }}
                    // onClick={(e) => e.stopPropagation()} // prevent card click
                    >
                      {/* <input
                        type="radio"
                        name="eeComponent" // SAME NAME = ONE GROUP
                        value={data.ee_id}
                        checked={selectedEE?.ee_id === data.ee_id}
                        onChange={(e) => {
                          e.stopPropagation();
                          setSelectedEE(data); // ONLY onChange
                        }}
                        style={{
                          width: 15,
                          height: 15,
                          accentColor: "#26890D",
                          cursor: "pointer",
                        }}
                      /> */}
                    </Box>
                  );
                }}
                renderCardActionIcons={(data) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        pt: 2,
                        pr: 2,
                      }}
                    >
                      <ChevronRightIcon />
                    </Box>
                  );
                }}
                getDataOnSearch={(data, resp) => {
                  if (resp.error) {
                    modifyEEData([]);
                  } else {
                    modifyEEData(resp.data);
                    setCount(resp.total_count);
                  }
                }}
                params={{
                  project_id: Number(projectID),
                  variant_id: Number(variantID),
                  ...(isZonalProject && { zone_position: selectedZone }),
                  status: "true",
                  page_number: page,
                  page_size: rowsPerPage,
                }}
                disabled={
                  !projectID || !variantID || projectID === 0 || variantID === 0
                }
              />
            </Box>
          </Box>
        </Box>
      )}

      {showZone === swm && (
        <Box>
          <Box sx={{ mb: 1 }}>
            <CommonBreadcrumbs
              color={"black"}
              items={[
                {
                  label: selectedEE?.assembly_number,
                  onClick: () => {
                    setShowZone(swm);
                  },
                },
                {
                  label: "Software Module",
                },
              ]}
            />
          </Box>
          <Box>
            <Box>
              <SelectComponentList
                key={`swm-${projectID}-${variantID}-${selectedEE?.ee_id}`}
                dataList={swmComponentModifiedList}
                apiAction={labCar.get_sw_modules_new}
                searchKey={"name"}
                placeholder={"Search Software Number"}
                page={page}
                rowsPerPage={rowsPerPage}
                handlePageChange={(page) => setPage(page)}
                totalCount={count}
                isItemDisabled={(item) =>
                  disabledSWMComponents.includes(Number(item?.data?.swm_id))
                }
                renderSelectIcon={(data) => {
                  const isDisabled = disabledSWMComponents.includes(
                    Number(data.swm_id),
                  );
                  return (
                    <Box sx={{ pl: 1.5, pt: 2 }}>
                      <Radio
                        name="swmComponent"
                        value={data.swm_id}
                        checked={selectedSWM?.swm_id === data.swm_id}
                        disabled={isDisabled}
                        onChange={(e) => {
                          e.stopPropagation();
                          if (!isDisabled) {
                            setSelectedSWM(data);
                          }
                        }}
                        icon={unCheckedIconStyle({ disabled: isDisabled })}
                        checkedIcon={checkedIconStyle({ disabled: isDisabled })}
                        sx={{
                          p: 0,
                          "&:hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                      />
                    </Box>
                  );
                }}
                renderCardActionIcons={(data) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        pt: 2,
                        pr: 2,
                      }}
                    >
                    </Box>
                  );
                }}
                getDataOnSearch={(data, resp) => {
                  if (resp.error) {
                    modifySWMData([]);
                  } else {
                    modifySWMData(resp.data);
                    setCount(resp.total_count);
                  }
                }}
                params={{
                  project_id: Number(projectID),
                  variant_id: Number(variantID),
                  ee_id: selectedEE?.ee_id,
                  status: "true",
                  page_number: page,
                  page_size: rowsPerPage,
                }}
                disabled={!projectID || !variantID || !selectedEE?.ee_id}
              />
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default SelectSWMDialog;
